import React from "react";
import Button from '@mui/material/Button';
import PatientAction from "./patientActionButtons";


const FamilyHistory = () => {
    return (
        <><PatientAction />
        <form>
            <div className="Family-info" >
                <div className="mt-3 ml-4"> <h4>Family History</h4></div>
                <div className="row" style={{ marginLeft:0, marginRight: 0 }}>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Father</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" Father="Father" />
                        </div>
                    </div>
                     <div className="form-group col-md-6">
                        <label for="lname" className="control-label col-sm">Mother</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="lname" placeholder="Mother" />
                        </div>
                    </div>
                   <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">Number Of Siblings</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="Number Of Siblings" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">GrandFather</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="GrandFather" />
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <label for="fname" className="control-label col-sm">GrandMother</label>
                        <div className="col-sm">
                            <input type="text" className="form-control" id="fname" placeholder="GrandMother" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end mr-4 mb-3">
                <Button variant="outlined">Submit</Button>
            </div>
        </form>
        </>
    );
};

export default FamilyHistory; 